// Version: 1.0 - Find ER Section Component
import React from 'react';
import './FindER.css';

const FindER: React.FC = () => {
  return (
    <section id="find-er" className="find-er">
      <div className="container">
        <div className="section-header">
          <h2>Find Your Nearest Emergency Room</h2>
          <p>
            Since headacheMD ER is currently a concept, we encourage you to locate 
            the nearest emergency room in your area for immediate care.
          </p>
        </div>

        <div className="find-er-content">
          <div className="search-options">
            <div className="search-card">
              <div className="search-icon google">
                <i className="fa fa-search"></i>
              </div>
              <h3>Search Online</h3>
              <p>Use Google or your preferred search engine to find emergency rooms near you.</p>
              <a 
                href="https://www.google.com/search?q=emergency+room+near+me" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-danger"
              >
                <i className="fa fa-external-link-alt"></i>
                Search "ER Near Me"
              </a>
            </div>

            <div className="search-card">
              <div className="search-icon maps">
                <i className="fa fa-map-marked-alt"></i>
              </div>
              <h3>Google Maps</h3>
              <p>Open Google Maps to see emergency rooms near your current location.</p>
              <a 
                href="https://www.google.com/maps/search/emergency+room+near+me" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-danger"
              >
                <i className="fa fa-map-marker-alt"></i>
                Open in Maps
              </a>
            </div>

            <div className="search-card">
              <div className="search-icon phone">
                <i className="fa fa-phone-alt"></i>
              </div>
              <h3>Emergency Services</h3>
              <p>Call 911 for immediate emergency assistance and ambulance dispatch.</p>
              <a 
                href="tel:911"
                className="btn btn-danger"
              >
                <i className="fa fa-phone"></i>
                Call 911
              </a>
            </div>
          </div>

          <div className="resources-section">
            <h3>Additional Resources</h3>
            <div className="resources-grid">
              <a 
                href="https://www.headacheMD.org" 
                target="_blank" 
                rel="noopener noreferrer"
                className="resource-link"
              >
                <i className="fa fa-leaf"></i>
                <div>
                  <strong>headacheMD.org</strong>
                  <span>Expert headache treatment and consultation</span>
                </div>
              </a>
              <a 
                href="https://headache.zone" 
                target="_blank" 
                rel="noopener noreferrer"
                className="resource-link"
              >
                <i className="fa fa-blog"></i>
                <div>
                  <strong>Headache Zone</strong>
                  <span>Medical blog and research articles</span>
                </div>
              </a>
              <a 
                href="https://www.americanmigrainefoundation.org" 
                target="_blank" 
                rel="noopener noreferrer"
                className="resource-link"
              >
                <i className="fa fa-heart"></i>
                <div>
                  <strong>American Migraine Foundation</strong>
                  <span>Patient resources and education</span>
                </div>
              </a>
              <a 
                href="https://headaches.org" 
                target="_blank" 
                rel="noopener noreferrer"
                className="resource-link"
              >
                <i className="fa fa-users"></i>
                <div>
                  <strong>National Headache Foundation</strong>
                  <span>Headache support and information</span>
                </div>
              </a>
            </div>
          </div>

          <div className="concept-reminder">
            <div className="reminder-icon">
              <i className="fa fa-info-circle"></i>
            </div>
            <div className="reminder-content">
              <h4>Remember: This is a Concept Website</h4>
              <p>
                headacheMD ER represents a vision for specialized emergency headache care that 
                does not currently exist as a physical facility. For all headache emergencies, 
                please visit your local emergency room or call 911.
              </p>
              <p>
                For non-emergency headache treatment, consider scheduling a consultation with 
                a headache specialist through{' '}
                <a href="https://www.headacheMD.org" target="_blank" rel="noopener noreferrer">
                  headacheMD.org
                </a>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FindER;
